import { makeStyles, tokens } from "@fluentui/react-components";
export const useChatComposeSectionStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusLarge,
        backgroundColor: tokens.colorNeutralBackground1
    },
    ribbonContainer: {
        width: "100%"
    },
    editorContainer: {
        maxHeight: "280px",
        overflowY: "auto",
        flex: "1 1 auto",
        width: "100%",
        boxSizing: "border-box",
        padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL} 0px ${tokens.spacingHorizontalL}`
    },
    buttonsContainer: {
        flex: "0 0 32px",
        width: "100%",
        boxSizing: "border-box",
        padding: tokens.spacingVerticalS,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    divider: {
        height: "80%",
        flex: 0,
        margin: `0 ${tokens.spacingHorizontalS}`
    }
});
